var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vg-content"},[_c('van-image',{staticClass:"logo",attrs:{"width":"100","height":"50","src":_vm.srcLogo}}),_c('div',{staticStyle:{"margin-top":"80px"},attrs:{"id":"qrcode"}}),_c('div',{staticClass:"text",staticStyle:{"margin-top":"15px"}},[_vm._v("扫码支付：¥"+_vm._s(_vm.price))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }